import React from 'react';
import { CheckIcon, ExternalLinkIcon } from 'lucide-react';
import { adminPoints, bookingSteps, demo, shots } from '../../data/offer';
import { Section } from './Section';
const websitePoints = ['Home, diensten, ons werk, studio en contact', 'Boekingsformulier met live prijsopbouw', 'Mobiel en desktop', 'Domein, hosting-setup en SSL'];
const planningPoints = ['Diensten en extra’s met prijs, duur en werkplaatstijd', 'Openingstijden, capaciteit en gesloten dagen', 'Alleen tijdsloten die echt vrij zijn', 'Bevestigingsmail naar klant en studio'];
const idealPoints = ['Aanbetaling online, restbedrag na de behandeling', 'Koppeling met Mollie (iDEAL)', 'Aanbetaald, openstaand en totaal bij de boeking'];
export function Product() {
  return <>
      <Section index="02" label="Onderdeel 1 · Website" title="Website met boekingsformulier" price="€ 800" duration="1,5 week" data-id="element-51" data-mp="mp803q4mfox9">
        <figure className="overflow-hidden rounded-xl border border-line bg-surface" data-id="element-52" data-mp="hsqypu8eve28">
          <img src={shots.site} alt="Homepage van de demo-website" className="w-full" loading="lazy" data-id="element-53" data-mp="26a6v8alr8tbq" />
        </figure>

        <figure className="mt-4 overflow-hidden rounded-xl border border-line bg-surface" data-id="element-54" data-mp="1xc3fxw1d4ssd">
          <img src={shots.booking} alt="Het boekingsformulier: behandeling en extra’s kiezen" className="w-full" loading="lazy" data-id="element-55" data-mp="22aoelr0yv4ep" />
        </figure>

        <ol className="mt-8 grid gap-6 md:grid-cols-4" data-id="element-56" data-mp="2tzrllek8msv1">
          {bookingSteps.map(item => <li key={item.step} className="border-t border-line pt-4" data-id="element-57" data-mp="2g0i3288k7mnw">
              <span className="text-xs font-semibold tabular-nums text-accent" data-id="element-58" data-mp="2kzl99w09zyxg">
                {item.step}
              </span>
              <h3 className="mt-2 text-base font-semibold tracking-tight text-white" data-id="element-59" data-mp="14kjnrmmsg4e8">
                {item.title}
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-white/55" data-id="element-60" data-mp="19iuzk2wn8oz3">
                {item.text}
              </p>
            </li>)}
        </ol>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-61" data-mp="lisx190el061">
          {websitePoints.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-62" data-mp="gphydv5qvpp7">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-63" data-mp="bqn49x2bueps" />
              <span data-id="element-64" data-mp="6todnohvgpwc">{item}</span>
            </li>)}
        </ul>

        <a href={demo.site} target="_blank" rel="noreferrer" className="mt-8 inline-flex items-center gap-2 rounded-full border border-line px-4 py-2 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/30 hover:bg-white/5" data-id="element-65" data-mp="1tsd5z8dvglj">
          dailycc.dstrct.website
          <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="1s5g53sdg9zn9" />
        </a>
      </Section>

      <Section index="03" label="Onderdeel 2 · Planning" title="Planning & beschikbaarheid" price="€ 600" duration="1 week" intro="De motor onder het formulier: diensten, duur en capaciteit bepalen welke tijdsloten de klant te zien krijgt." data-id="element-67" data-mp="1n7eln6c43yb9">
        <ul className="grid gap-3 sm:grid-cols-2" data-id="element-68" data-mp="24gpjvtkspjga">
          {planningPoints.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-69" data-mp="29dz855wg7p2j">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-70" data-mp="1bstp4uese1m5" />
              <span data-id="element-71" data-mp="1gro3nk5q140g">{item}</span>
            </li>)}
        </ul>
      </Section>

      <Section index="04" label="Onderdeel 3 · Beheeromgeving" title="Agenda, boekingen en omzet" price="€ 1.200" duration="1,5 week" data-id="element-72" data-mp="1lpg6vabtgcjy">
        <figure className="overflow-hidden rounded-xl border border-line bg-surface" data-id="element-73" data-mp="2x54snydc35j6">
          <img src={shots.dashboard} alt="Dashboard van de beheeromgeving met omzet, aanvragen en boekingen" className="w-full" loading="lazy" data-id="element-74" data-mp="316gbnl1pcsie" />
        </figure>

        <figure className="mt-4 overflow-hidden rounded-xl border border-line bg-surface" data-id="element-75" data-mp="2uqq12jxn50hm">
          <img src={shots.agenda} alt="Maandagenda met afspraken per dag" className="w-full" loading="lazy" data-id="element-76" data-mp="39o06bbjoxa4w" />
        </figure>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-77" data-mp="3io5dplovw8j2">
          {adminPoints.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-78" data-mp="3dp27hxx63w9i">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-79" data-mp="3dn7vj93vjehk" />
              <span data-id="element-80" data-mp="3sft0vaeer3eq">{item}</span>
            </li>)}
        </ul>
      </Section>

      <Section index="05" label="Onderdeel 4 · Betaling" title="Online betaling via iDEAL" price="€ 400" duration="3 dagen" data-id="element-81" data-mp="3ngyiuao9livo">
        <div className="grid gap-8 lg:grid-cols-12" data-id="element-82" data-mp="18yk8477zqcj">
          <figure className="overflow-hidden rounded-xl border border-line bg-surface lg:col-span-7" data-id="element-83" data-mp="jw7g37e81340">
            <img src={shots.bookingDetail} alt="Boekingsdetail met aanbetaling, openstaand bedrag en totaal" className="w-full" loading="lazy" data-id="element-84" data-mp="ousgp7xdxosz" />
          </figure>

          <ul className="space-y-3 lg:col-span-5" data-id="element-85" data-mp="ftb1rsvprt5v">
            {idealPoints.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/75" data-id="element-86" data-mp="14ey080ox2b2">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-87" data-mp="5wg5lgmwy4ur" />
                <span data-id="element-88" data-mp="3oayxd5emy2j3">{item}</span>
              </li>)}
          </ul>
        </div>
      </Section>
    </>;
}